<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row" style="display:none;">
      <div class="col-12 p-0 m-0">
        <filter-container-small v-bind:user="$store.getUsername()" v-bind:key="filter.id + 'filter'" ref="filterContainer" @change="doChange"></filter-container-small>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 col-md-3">

        <h3 class="mb-0">{{title}}</h3>

        <div v-for="row in tabledata.filter((item, pos, self) => self.findIndex(v => v.AssignTo === item.AssignTo) === pos)">

          <contact-card @selectdate="selectdate" v-if="row.AssignTo != null && row.AssignTo != '' && row.AssignTo != 'null'" v-bind:username="row.AssignTo"></contact-card>

        </div>

      </div>
      <div class="col-12 col-md-9 p-0 m-0">
        <basic-table ref="procedureTable" v-bind:hidestats="true" v-bind:enablepaging="false" @page_change="pageChange" @columnschanged="columnschanged" v-bind:key="filter.id + 'table'" v-bind:rowclick="rowclick" enableedit="true" enabledragging="false" v-bind:responsive="true" tablecss="skin">
          <template slot="UserIcon" scope="childDataScope">
            <img v-if="childDataScope.row.UserIcon != null" v-bind:src="'/api/membership/v1/GetSquareImage?username=' + childDataScope.row.UserIcon" class="rounded-circle mr-2" alt="" width="34" height="34">
          </template>
          <template slot="QuickDone" scope="childDataScope">
            <span class="colorlabel p-0 m-0" v-bind:style="'width:5px;margin-right:10px !important;height:100% !important;position:absolute;top:0px;display:inline-table;background-color:' + childDataScope.row.CategoryColour">&nbsp;</span>
            <div v-if="childDataScope.row.AssignTo != null && childDataScope.row.AssignTo.trim() == $store.getUsername().trim()" class="custom-control custom-checkbox custom-control-inline" v-bind:style="'float:left;margin-left:15px;border-left-width:5px;border-left-color:' + childDataScope.row.CategoryColour">
              <input class="custom-control-input" v-bind:class="{'chk-success':childDataScope.row.Status == 2,'chk-notdone':childDataScope.row.Status > 2}" type="checkbox" v-bind:id="childDataScope.row.ProcedureScheduleId + '_quickdonechk'" @click="onToggleStatus(index, childDataScope.row)" v-bind:checked="childDataScope.row.Status == 2  || childDataScope.row.Status > 2" style="padding:0px;top:-4px;" />
              <label class="custom-control-label" v-bind:class="{'chk-success':childDataScope.row.Status == 2,'chk-notdone':childDataScope.row.Status > 2}" v-bind:for="childDataScope.row.ProcedureScheduleId + '_quickdonechk'" style="padding:0px;top:-4px;"></label>
            </div>

            <div v-if="childDataScope.row.AssignTo == null || childDataScope.row.AssignTo.trim() != $store.getUsername().trim()" class="custom-control custom-checkbox custom-control-inline disabled" v-bind:style="'float:left;margin-left:15px;border-left-width:5px;border-left-color:' + childDataScope.row.CategoryColour">
              <input class="custom-control-input" disabled="disabled" v-bind:class="{'chk-success':childDataScope.row.Status == 2,'chk-notdone':childDataScope.row.Status > 2}" type="checkbox" v-bind:id="childDataScope.row.ProcedureScheduleId + '_quickdonechk'" v-bind:checked="childDataScope.row.Status == 2 || childDataScope.row.Status > 2" style="padding:0px;top:-4px;" />
              <label class="custom-control-label" v-bind:class="{'chk-success':childDataScope.row.Status == 2,'chk-notdone':childDataScope.row.Status > 2}" v-bind:for="childDataScope.row.ProcedureScheduleId + '_quickdonechk'" style="padding:0px;top:-4px;"></label>
            </div>
          </template>
          <template slot="TaskNumber" scope="childDataScope">
            #{{childDataScope.row.TaskNumber}}
          </template>
          <template slot="AssignTo" scope="childDataScope">
            {{childDataScope.row.AssignToFullName}}
          </template>

          <template slot="menu" scope="childDataScope" v-if="this.$store.getUserPermissionLevel() > 3">
            <a v-show="childDataScope.row.Locked == true" class="dropdown-item">
              Unable to edit tasks in the future
            </a>

            <a v-show="childDataScope.row.Locked == false && childDataScope.row.ParentProcedureId != null && childDataScope.row.IsOwner == true" @click="onRowClick(index, childDataScope.row, 'edit')" href="#" class="dropdown-item">{{$t('edit')}}</a>

            <a v-show="childDataScope.row.Locked == false  && childDataScope.row.ParentProcedureId == null && childDataScope.row.IsOwner == true" @click="onRowClick(index, childDataScope.row, 'edit')" href="#" class="dropdown-item">{{$t('edit')}}</a>
            <a v-show="childDataScope.row.Locked == false" @click="onRowClick(index, childDataScope.row, 'assign')" class="dropdown-item">{{$t('assign')}}</a>


            <a v-if="childDataScope.row.IsTask == true && childDataScope.row.Locked == false && childDataScope.row.IsOwner == true && childDataScope.row.ParentProcedureId == null" @click="onRowClick(index, childDataScope.row, 'convert')" class="dropdown-item">{{$store.translate('convert_to_shared_procedure')}}</a>
            <a v-show="childDataScope.row.Locked == false" @click="onRowClick(index, childDataScope.row, 'delete')" class="dropdown-item">{{$t('delete')}}</a>

            <div v-show="childDataScope.row.Locked == false" class="dropdown-submenu dropdown-submenu-left">
              <a v-on:click.stop="childDataScope.toggleShow('#sub' + childDataScope.index)" class="dropdown-item dropdown-toggle" data-display="static" data-boundary="viewport">{{$t('change_status')}}</a>
              <div v-bind:id="'sub' + childDataScope.index" class="skinnedmenu dropdown-menu mobile-submenu" data-boundary="viewport" style="min-width: 80px !important">

                <a @click="onRowClick(index, childDataScope.row, 'setstatus', '1')" v-bind:href="'javascript:setStatus(' + childDataScope.row.ProcedureId + ',' + childDataScope.row.Date + ',' + childDataScope.row.ProcedureScheduleId + ', 1)'" class="dropdown-item" style="white-space: normal !important;">{{$t('started')}}</a>
                <a @click="onRowClick(index, childDataScope.row, 'setstatus', '2')" v-bind:href="'javascript:setStatus(' + childDataScope.row.ProcedureId + ',' + childDataScope.row.Date + ',' + childDataScope.row.ProcedureScheduleId + ', 2)'" class="dropdown-item" style="white-space: normal !important;">{{$t('done')}}</a>
                <a @click="onRowClick(index, childDataScope.row, 'setstatus', '6')" v-bind:href="'javascript:setStatus(' + childDataScope.row.ProcedureId + ',' + childDataScope.row.Date + ',' + childDataScope.row.ProcedureScheduleId + ', 6)'" class="dropdown-item" style="white-space: normal !important;">{{$t('notdone')}}</a>
                <a @click="onRowClick(index, childDataScope.row, 'setstatus', '4')" v-bind:href="'javascript:setStatus(' + childDataScope.row.ProcedureId + ',' + childDataScope.row.Date + ',' + childDataScope.row.ProcedureScheduleId + ', 4)'" class="dropdown-item" style="white-space: normal !important;">{{$t('closed')}}</a>
              </div>
            </div>

            <div v-show="childDataScope.row.Locked == false" class="dropdown-submenu dropdown-submenu-left">
              <a v-on:click.stop="childDataScope.toggleShow('#prio' + childDataScope.index)" class="dropdown-item dropdown-toggle" data-display="static" data-boundary="viewport">{{$t('change_priority')}}</a>
              <div v-bind:id="'prio' + childDataScope.index" class="skinnedmenu dropdown-menu mobile-submenu" data-boundary="viewport" style="min-width: 80px !important">
                <a @click="onRowClick(index, childDataScope.row, 'setpriority', '0')" v-bind:href="'javascript:setPriority(' + childDataScope.row.ProcedureScheduleId + ', 0)'" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_low')}}</a>
                <a @click="onRowClick(index, childDataScope.row, 'setpriority', '1')" v-bind:href="'javascript:setPriority(' + childDataScope.row.ProcedureScheduleId + ', 1)'" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_medium')}}</a>
                <a @click="onRowClick(index, childDataScope.row, 'setpriority', '2')" v-bind:href="'javascript:setPriority(' + childDataScope.row.ProcedureScheduleId + ', 2)'" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_high')}}</a>
              </div>


            </div>
          </template>

          <template slot="multiplemenu" scope="childDataScope">
            <div class="py-1" style="padding-left:15px !important">{{$t('multiple_selected')}}</div>
            <div v-show="childDataScope.row.Locked == false" class="dropdown-submenu dropdown-submenu-left">
              <a v-on:click.stop="childDataScope.toggleShow('#mulStatus' + childDataScope.index)" class="dropdown-item dropdown-toggle" data-display="static" data-boundary="viewport">{{$t('change_status')}}</a>
              <div v-bind:id="'mulStatus' + childDataScope.index" class="skinnedmenu dropdown-menu mobile-submenu" data-boundary="viewport" style="min-width: 80px !important">
                <a @click="onMultipleRowclick('setstatus', '1')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('started')}}</a>
                <a @click="onMultipleRowclick('setstatus', '2')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('done')}}</a>
                <a @click="onMultipleRowclick('setstatus', '6')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('notdone')}}</a>
                <a @click="onMultipleRowclick('setstatus', '4')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('closed')}}</a>
              </div>
            </div>
            <div v-show="childDataScope.row.Locked == false" class="dropdown-submenu dropdown-submenu-left">
              <a v-on:click.stop="childDataScope.toggleShow('#mulprio' + childDataScope.index)" class="dropdown-item dropdown-toggle" data-display="static" data-boundary="viewport">{{$t('change_priority')}}</a>
              <div v-bind:id="'mulprio' + childDataScope.index" class="skinnedmenu dropdown-menu mobile-submenu" data-boundary="viewport" style="min-width: 80px !important">
                <a @click="onMultipleRowclick('setpriority', '0')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_low')}}</a>
                <a @click="onMultipleRowclick('setpriority', '1')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_medium')}}</a>
                <a @click="onMultipleRowclick('setpriority', '2')" href="#" class="dropdown-item" style="white-space: normal !important;">{{$t('priority_high')}}</a>
              </div>
            </div>
            <a @click="onMultipleRowclick('delete', '0')" href="#" class="dropdown-item">{{$t('delete')}}</a>
          </template>

          <template slot="ProcedureName" scope="childDataScope">
            <a style="color:inherit;" v-bind:href="'javascript:procedureDetail(' + childDataScope.row.ProcedureId + ',' + childDataScope.row.ProcedureScheduleId + ',' + childDataScope.index + ',' +  false + ',\'' + childDataScope.row.AssignTo + '\')'"><u>{{childDataScope.row.ProcedureName}}</u></a>
          </template>

          <template slot="SchMessagesCount" scope="childDataScope">

            <span v-if="childDataScope.row.SchMessagesCount > 0" class="badge badge-warning badge-pill ml-auto ml-lg-0">
              {{childDataScope.row.SchMessagesCount}}
            </span>
            <span v-if="childDataScope.row.SchMessagesCount == 0" class="badge badge-warning badge-pill ml-auto ml-lg-0">

            </span>


          </template>

          <template slot="Status" scope="childDataScope">
            <nobr>




              <span v-if="childDataScope.row.Status == 0">{{$t('created')}}</span>
              <span v-if="childDataScope.row.Status == 1">{{$t('started')}}</span>
              <span v-if="childDataScope.row.Status == 2">{{$t('done')}}</span>
              <span v-if="childDataScope.row.Status == 3">{{$t('verified')}}</span>
              <span v-if="childDataScope.row.Status == 4">{{$t('closed')}}</span>
              <span v-if="childDataScope.row.Status == 5">{{$t('scheduled')}}</span>
              <span v-if="childDataScope.row.Status == 6">{{$t('not_done')}}</span>

              <span v-if="childDataScope.row.Status == 20">{{$t('status_notime')}}</span>
              <span v-if="childDataScope.row.Status == 21">{{$t('status_notable')}}</span>
              <span v-if="childDataScope.row.Status == 22">{{$t('status_missing_information')}}</span>
              <span v-if="childDataScope.row.Status == 23">{{$t('status_notneeded')}}</span>

            </nobr>
          </template>
          <template slot="Priority" scope="childDataScope">
            <img v-if="childDataScope.row.Priority == 0" v-bind:src="'/api/membership/getcolor?color=%23A9D18E'" class="rounded-circle mr-2" alt="" width="15" height="15" style="margin-right: 2px !important; margin-top: -4px;">
            <img v-if="childDataScope.row.Priority == 1" v-bind:src="'/api/membership/getcolor?color=%23ED7D31'" class="rounded-circle mr-2" alt="" width="15" height="15" style="margin-right: 2px !important; margin-top: -4px;">
            <img v-if="childDataScope.row.Priority == 2" v-bind:src="'/api/membership/getcolor?color=%23FF0000'" class="rounded-circle mr-2" alt="" width="15" height="15" style="margin-right: 2px !important; margin-top: -4px;">
            <span v-if="childDataScope.row.Priority == 0">{{$t('priority_low')}}</span>
            <span v-if="childDataScope.row.Priority == 1">{{$t('priority_medium')}}</span>
            <span v-if="childDataScope.row.Priority == 2">{{$t('priority_hight')}}</span>
          </template>
          <template slot="ReadyState" scope="childDataScope">
            <span class="label-contrast">
              <nobr>
                {{childDataScope.row.ReadyState}} %
              </nobr>
            </span>
          </template>

        </basic-table>
      </div>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'viewmaker-tableview',
    components: {
    },
    data() {
      return {
        showTable: false,
        page: 1,
        title: '',
        tabledata: []
      }
    },
    props: {
      filter: {
        id:null,
        required: false,
        type: Object,
        default: {type : "", data: null, text: ""}
      },
      rowclick: {
        required: false,
        type: String,
        default: ''
      },
      togglestatus: {
        required: false,
        type: String,
        default: ''
      },
      multiplerowclick: {
        required: false,
        type: String,
        default: ''
      },
      headerdata: {
        required: false,
        type: Array,
        default: []
      },
      
    },
    methods: {
      selectdate(date) {
        this.$emit("changed", date);
      },
      columnschanged(headerdata) {
        this.$root.$emit("tableviewcolumnschanged", headerdata);
      },
      onToggleStatus(index, row) {
        var tableComponent = this.$refs.procedureTable;
        if (this.togglestatus != null) {
          eval(this.togglestatus + "(index, row, tableComponent)")
        }
      },
      onRowClick(index, row, command, param) {
        var tableComponent = this.$refs.procedureTable;
        if (this.rowclick != null) {
          eval(this.rowclick + "(index, row, tableComponent, command, param)")
        }
      },
      onMultipleRowclick(command, param) {
        var selectedRows = this.$refs.procedureTable.getSelected();
        if (this.multiplerowclick != null) {
          eval(this.multiplerowclick + "(selectedRows, command, param)")
        }
      },
      doChange() {
        //this.getData();
      },
      loadTodo() {

      },
      reloadSearch() {
        //this.getData();
      },
      getAbbreviation(longname) {
        if (longname == null || longname == "")
          return "";

        var nameArr = longname.trim().split(' ');
        var abbreviation = "";
        for (var i = 0; i < nameArr.length; i++) {
        abbreviation += nameArr[i].substring(0, 1);
        }
        abbreviation = abbreviation.toUpperCase();
        return abbreviation;
      },
      getData() {
        this.showTable = true;
        var buttons = this.$refs.filterContainer.getCurrentFilter();
        var tempTitle = "";
        var filters = [];
        for (var i = 0; i < buttons.length; i++) {
          filters.push({
            type: buttons[i].type,
            data: buttons[i].config.data,
            customstyle: buttons[i].config.customstyle,
            abbreviation: buttons[i].config.abbreviation,
            icon: buttons[i].config.icon,
            text: buttons[i].config.text,
            customclass: buttons[i].config.customclass,
            menu: null
          });
          if (buttons[i].config.text != "D") {
            if (tempTitle == "")
              tempTitle += buttons[i].config.text;
            else
              tempTitle += " > " + buttons[i].config.text;
          }
        }

        var requestContent_old = {
          filters: filters,
          page: this.page,
          paggingRecord: 80
        }

        var todaydate = moment().format('YYYY-MM-DD')

        //TODO migration, implement the same way as in other filters
        for (var i = 0; i < filters.length; i++) {
          filters[i].data = filters[i].data.toString();
        }

        var requestContent = {
          filters: filters,
          page: this.page,
          sortDirection: "asc",
          sortingColumn: null,
          todaydate: todaydate,
          paggingRecord: 80
        }



        var stringPayload = JSON.stringify(requestContent);

        try {
          //application/x-www-form-urlencoded

          

          this.$http.post('/api/Procedures/v1/GetProceduresByMultipleFilter',
            requestContent
            ).then(async response => {
              var tabledata = response.data.Result;

              var totalRecods = 0;
              if (tabledata.length > 0)
                totalRecods = tabledata[0].TotalCount;

              

              if (totalRecods > 80) {
                this.$refs.procedureTable.isServerSorting = true;
                this.$refs.procedureTable.setPaging(true, this.page - 1, totalRecods, 80);
              }
              else {
                this.$refs.procedureTable.enablePaging = false;
              }


            this.$refs.procedureTable.setData(null, tabledata);
            this.$refs.procedureTable.sort();
            this.$refs.procedureTable.render();
            this.tabledata = tabledata;

              this.title = tempTitle

          });
        } catch (err) {
          alert('some error:' + err)
        }

        /*
        var onSuccess = function (data) {
          var tabledata = data.Result;
          this.$refs.procedureTable.setData(null, tabledata);
          this.$refs.procedureTable.sort();
          this.$refs.procedureTable.render();

        };
        var onError = function (data) {
          alert("error")
        };

        SimplePost("/api/Procedure/GetProceduresByFilter", stringPayload, onSuccess, onError);
        */

      },
      clearSelected() {
        this.$refs.procedureTable.clearSelected();
      },
      formatDates(dates) {
        if (dates == null)
          return "";
        else if (typeof (dates) == "string")
          return dates.replace(/,/g, '<br>');
        return dates.toString()
      },
      initFilter(filterParam) {

        var filter = null;
        if (filterParam != null) {
          filter = JSON.parse(JSON.stringify(filterParam));
        }
        else {
          filter = JSON.parse(JSON.stringify(this.filter));
        }
          

        this.$refs.filterContainer.clearFilters();

        var filterConfig =
        {
          customstyle: "background-color:rgba(122,176,197,0.8)",
          customclass: "",
          abbreviation: this.getAbbreviation(filter.text),
          data: filter.data,
          text: filter.text,
          icon: null,
          cssIcon: null,
          visible: filter.visible == true
        };

        this.$refs.filterContainer.addInvisibleButton(filter.type, filterConfig, false)

        if (filter.filters && filter.filters != null) {
          for (var i = 0; i < filter.filters.length; i++) {
            if (filter.filters[i].type) {
              var tmpConfig =
              {
                customstyle: "background-color:rgba(122,176,197,0.8)",
                customclass: "",
                abbreviation: this.getAbbreviation(filter.filters[i].text),
                data: filter.filters[i].data,
                text: filter.filters[i].text,
                icon: null,
                cssIcon: null,
                visible: filter.filters[i].visible == true
              };
              if (i == filter.filters.length - 1)
                this.$refs.filterContainer.addButton(filter.filters[i].type, tmpConfig, false)
              else
                this.$refs.filterContainer.addInvisibleButton(filter.filters[i].type, tmpConfig, false)
            }
          }
        }

        this.getData();
      },
      pageChange(data) {
        
        var obj = data !== undefined ? JSON.parse(data) : null;
        //console.log(obj);
        if (obj !== null && obj.pagenumber !== undefined) {
          this.page = obj.pagenumber + 1;
          this.getData();
        }
      },
      changeHeaderData(headerdata) {
        this.headerdata = headerdata;
        this.$refs.procedureTable.setHeaderData(headerdata);
        //alert("changeHeaderData")
      }
    },
    created() {

    },
    mounted() {

      this.$root.$on('tableviewcolumnschanged', this.changeHeaderData);
      
      this.$refs.procedureTable.setPerPageRecord(80);
      /*
      this.headerdata = [

        { headername: this.$t('user'), columnname: "UserIcon", css: "", datahide: "", enabled: false, databreakpoints: "", hideheader: true },
        { headername: this.$t('check'), columnname: "QuickDone", css: "", datahide: "", enabled: true, databreakpoints: "", hideheader: true },
        { headername: "Id", columnname: "ProcedureScheduleId", css: "", datahide: "", enabled: true, databreakpoints: "", isId: true },
        { headername: "#", columnname: "TaskNumber", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('name'), columnname: "ProcedureSchuleName", css: "", datahide: "", enabled: true, databreakpoints: "" },
        { headername: this.$t('location'), columnname: "ParentLocation", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('sub_location'), columnname: "Location", css: "", datahide: "", enabled: true, databreakpoints: "" },
        { headername: this.$t('date'), columnname: "DatescheduledString", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('team'), columnname: "TeamName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('status'), columnname: "Status", css: "", datahide: "", enabled: true, databreakpoints: "" },
        { headername: this.$t('ready'), columnname: "ReadyState", css: "", datahide: "", enabled: true, databreakpoints: "" },
        { headername: this.$t('time_estimated'), columnname: "EstimatedTime", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('time_spent'), columnname: "ActualTime", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('priority'), columnname: "Priority", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('project'), columnname: "ProjectName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('client'), columnname: "OrganisationName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('assigned_to'), columnname: "AssignTo", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('shift'), columnname: "ShiftName", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('created'), columnname: "DateCreated", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('modified'), columnname: "DateModified", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('created_by'), columnname: "CreatedBy", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('response_time'), columnname: "ResponseTimeLable", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: this.$t('resolution_time'), columnname: "ResolutionTimeLable", css: "", datahide: "", enabled: false, databreakpoints: "" },
        { headername: "ParentProcedureId", columnname: "ParentProcedureId", css: "", datahide: "", enabled: false, visible: false, databreakpoints: "" },
        { headername: this.$t('message_count'), columnname: "SchMessagesCount", css: "", datahide: "", enabled: true, databreakpoints: "", hideheader: true },
      ];
      */
      this.$refs.procedureTable.setHeaderData(this.headerdata);

      this.initFilter(null);

      if (typeof (this.filter.type) != "undefined" && this.filter.type != null && this.filter.type != "") {

        //this.initFilter(this.filter);

        /*
        this.$refs.filterContainer.clearFilters();

        var filterConfig =
        {
          customstyle: "background-color:rgba(122,176,197,0.8)",
          customclass: "",
          abbreviation: this.getAbbreviation(this.filter.text),
          data: this.filter.data,
          text: this.filter.text,
          icon: null,
          cssIcon: null,
        };

        this.$refs.filterContainer.addButton(this.filter.type, filterConfig, false)

        
        //var filters = [];


        if (this.filter.filters && this.filter.filters != null) {
          for (var i = 0; i < this.filter.filters.length; i++) {

            var tmpConfig =
            {
              customstyle: "background-color:rgba(122,176,197,0.8)",
              customclass: "",
              abbreviation: this.getAbbreviation(this.filter.filters[i].text),
              data: this.filter.filters[i].data,
              text: this.formatDates(this.filter.filters[i].data),
              icon: null,
              cssIcon: null,
            };

            this.$refs.filterContainer.addButton(this.filter.filters[i].type, tmpConfig, false)
          }
        }
        */
      }

      //this.$root.$on('doSearch', this.reloadSearch);
      this.$root.$on('doSearch', this.getData)

      // Initialize the menu
      App.initDropdownSubmenu();

    },

    watch: {
      headerdata: function (newVal, oldVal) {

      },
      filter: function (newVal, oldVal) {
        this.initFilter(newVal);
        if (typeof (newVal.type) != "undefined" && newVal.type != null && newVal.type != "") {
          //this.initFilter(this.filter)

          /*
          var buttonData =
          {
            customstyle: "background-color:rgba(122,176,197,0.8)",
            customclass: "",
            abbreviation: this.getAbbreviation(newVal.text),
            data: newVal.data,
            text: null,
            icon: null,
            cssIcon: null
          };

          this.$refs.filterContainer.clearFilters();

          this.$refs.filterContainer.addButton(newVal.type, buttonData, false)

          if (newVal.filters && newVal.filters != null) {
            for (var i = 0; i < newVal.filters.length; i++) {

              var tmpConfig =
              {
                customstyle: "background-color:rgba(122,176,197,0.8)",
                customclass: "",
                abbreviation: this.getAbbreviation(newVal.filters[i].text),
                data: newVal.filters[i].data,
                text: this.formatDates(newVal.filters[i].data),
                icon: null,
                cssIcon: null,
              };

              this.$refs.filterContainer.addButton(newVal.filters[i].type, tmpConfig, false)
            }
          }

          //this.getData();
           */
        }

        //this.$forceUpdate();
       
      },
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/viewmaker/viewmaker-tableview.vue